var map = {
	"./de/returnBtn.png": "JJbH",
	"./en/returnBtn.png": "ONcE",
	"./es/returnBtn.png": "e+yq",
	"./fr/returnBtn.png": "pJvs",
	"./ja/returnBtn.png": "KeEh",
	"./ko/returnBtn.png": "oAAH",
	"./pt/returnBtn.png": "c7N4",
	"./ru/returnBtn.png": "0tqc",
	"./tc/returnBtn.png": "Xi1z",
	"./th/returnBtn.png": "4Rji"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9Xxl";